import { XMarkIcon } from "@heroicons/react/24/outline";
import { WeightedSkill } from "./types";

type SkillsSectionProps = {
  skills: WeightedSkill[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, key: keyof WeightedSkill, value: string | number) => void;
};

export default function SkillsSection({ skills, onAdd, onRemove, onChange }: SkillsSectionProps) {
  return (
    <div className="space-y-2">
      {skills.length > 0 && (
        <div className="grid grid-cols-[1fr_100px_36px] gap-2 px-1 mb-1">
          <span className="text-xs font-medium text-gray-500 dark:text-gray-400">Skill name</span>
          <span className="text-xs font-medium text-gray-500 dark:text-gray-400">Weight</span>
          <span />
        </div>
      )}
      {skills.map((skill, index) => (
        <div key={index} className="grid grid-cols-[1fr_100px_36px] items-center gap-2">
          <input
            className="rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 bg-white dark:bg-darkbg placeholder-gray-400 focus:border-entntblue focus:outline-none focus:ring-1 focus:ring-entntblue/20 transition-colors"
            placeholder="e.g. React, Python…"
            value={skill.name}
            onChange={(e) => onChange(index, "name", e.target.value)}
          />
          <input
            type="number"
            min={0}
            className="remove-arrow rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 bg-white dark:bg-darkbg focus:border-entntblue focus:outline-none focus:ring-1 focus:ring-entntblue/20 transition-colors"
            placeholder="0"
            value={skill.weight}
            onChange={(e) => onChange(index, "weight", Number(e.target.value))}
          />
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-red-300 dark:border-red-700 text-red-400 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            onClick={() => onRemove(index)}
            aria-label="Remove skill"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button
        type="button"
        className="mt-1 inline-flex items-center gap-1.5 rounded-lg border border-dashed border-entntblue/40 px-3 py-2 text-sm font-medium text-entntblue hover:border-entntblue hover:bg-entntblue/5 transition-colors"
        onClick={onAdd}
      >
        <span className="text-base leading-none">+</span> Add Skill
      </button>
    </div>
  );
}
